// CSS `column-count` rebalances every column on each layout pass, so appending
// items (Load more) reflows tiles already on screen into new positions. Assigning
// items to columns by index instead keeps every previously-placed tile's column
// and order fixed as more items are appended.
export function distributeColumns<T>(items: T[], columnCount: number): T[][] {
  const columns: T[][] = Array.from({ length: columnCount }, () => []);
  items.forEach((item, i) => {
    columns[i % columnCount]!.push(item);
  });
  return columns;
}

const BREAKPOINTS: { maxWidth: number; columns: number }[] = [
  { maxWidth: 500, columns: 1 },
  { maxWidth: 800, columns: 2 },
];

export function columnCountForWidth(width: number): number {
  for (const bp of BREAKPOINTS) {
    if (width <= bp.maxWidth) return bp.columns;
  }
  return 3;
}
